import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface ChangeStatusParams {
  lrns: string;
  status: string;
  batchCounter: number;
}

export const useChangeStatusDeclarations = () => {
  return useMutation({
    mutationFn: async ({ lrns, status, batchCounter }: ChangeStatusParams) => {
      return request({
        path: 'admin/change-status-declarations',
        method: 'POST',
        authenticate: true,
        dataObject: { lrns, status, batchCounter },
      });
    },
    onSuccess: () => {
      toast.success('Declarations status updated!');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error updating declarations status!');
    },
  });
};
